import { condClass } from 'app/utils/general';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import classes from './MDatetimePicker.module.scss';

interface Props {
  datePickerRef: React.RefObject<DatePicker<unknown>>;
  className?: string;
  value?: Date | null;
  name?: string;
  placeholder?: string;
  showTimeSelect?: boolean;
  showTimeSelectOnly?: boolean;
  timeIntervals?: number;
  timeCaption?: string;
  minDate?: Date;
  maxDate?: Date;
  dateFormat?: string;
  disabled?: boolean;
  weekDays?: number[];
  holidays?: moment.Moment[];
  onChange: (date: Date | null) => void;
}

const MDatetimePickerView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <DatePicker
      ref={props.datePickerRef}
      name={props.name}
      className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}
      calendarClassName={classes['calendar']}
      dayClassName={() => classes['day']}
      popperClassName={classes['popper']}
      monthClassName={() => classes['month']}
      weekDayClassName={() => classes['weekDay']}
      wrapperClassName={classes['wrapper']}
      autoComplete="off"
      placeholderText={props.placeholder}
      showTimeSelectOnly={props.showTimeSelectOnly}
      showTimeSelect={props.showTimeSelect}
      selected={props.value}
      timeFormat="HH:mm"
      onChange={props.onChange}
      minDate={props.minDate}
      maxDate={props.maxDate}
      minTime={props.minDate}
      maxTime={moment().hours(23).minutes(59).toDate()}
      timeIntervals={props.timeIntervals || 15}
      dateFormat={props.dateFormat || 'MMM d yyyy HH:mm'}
      disabled={props.disabled}
      filterDate={(date: Date) => {
        const weekDay = date.getDay();

        if (props.holidays) {
          for (const holiday of props.holidays) {
            if(holiday.isSame(moment(date))){
              return true;
            }
          }
        }

        if (!props.weekDays) {
          return true;
        }

        return !!props.weekDays?.includes(weekDay);
      }}
    ></DatePicker>
  );
};

export default MDatetimePickerView;
